// Shared loading / error / empty states — so every view shows the same
// spinner + structural hint instead of bare "Loading…" text, and fetch
// errors get a working Retry instead of a dead end.

export function Spinner({ size = 16, className = '' }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={`inline-block animate-spin rounded-full border-2 border-muted-foreground/30 border-t-foreground ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

// Block-level loading state with an optional label.
export function LoadingState({ label = 'Loading…', className = '' }) {
  return (
    <div className={`flex items-center gap-2 text-muted-foreground text-sm py-4 ${className}`}>
      <Spinner />
      <span>{label}</span>
    </div>
  );
}

// Terminal fetch error with a Retry affordance. `onRetry` re-runs the load.
export function ErrorState({ error, onRetry, className = '' }) {
  const msg = typeof error === 'string' ? error : error?.message || 'Something went wrong.';
  return (
    <div className={`text-sm py-4 ${className}`}>
      <div className="text-destructive mb-2">Error: {msg}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="text-xs px-2 py-1 border border-input rounded-md hover:bg-accent"
        >Retry</button>
      )}
    </div>
  );
}

// Consistent muted empty state.
export function EmptyState({ children, className = '' }) {
  return (
    <div className={`text-sm text-muted-foreground italic py-4 ${className}`}>
      {children}
    </div>
  );
}
